import ListSampleReceiptItem from './ListSampleReceiptItem';
import { type SampleReceipt } from '../../../common/types';

interface IProps {
  items: SampleReceipt[];
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  handleDeletingItem: (item: SampleReceipt) => any;
  handleSelectItem: (item: SampleReceipt) => any;
}

const ListSampleReceipts: React.FC<IProps> = ({
  items: records,
  toggleEditModal,
  toggleDeleteModal,
  handleDeletingItem,
  handleSelectItem
}) => {
  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full p-4 border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left">Title</th>
              <th className="p-2 text-sm font-semibold text-left">Receipt</th>
              <th className="p-2 text-sm font-semibold text-left">Type</th>
              <th className="p-2 text-sm font-semibold text-left ">Owner ID</th>
              <th className="p-2 pr-8 text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {records.map((record) => {
              return (
                <ListSampleReceiptItem
                  key={record.id}
                  item={record}
                  toggleEditModal={toggleEditModal}
                  toggleDeleteModal={toggleDeleteModal}
                  handleDeletingItem={handleDeletingItem}
                  handleSelectItem={handleSelectItem}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListSampleReceipts;
